module.exports = __webpack_public_path__ + "static/img/5btn2.0a01504.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/5btn2.png
// module id = q4Ga
// module chunks = 215